import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';

// @mui
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';

import TextField from '@mui/material/TextField';

import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import * as Yup from 'yup';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useBoolean } from 'src/hooks/use-boolean';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import {
  endpoints,
  getFetcherPramspdf,
  postPramsFetcher1,
  postPramsFetcher2,
} from 'src/utils/axios';
import { enqueueSnackbar } from 'notistack';
import { RHFAutocomplete } from 'src/components/hook-form';
import { set } from 'lodash';

// ----------------------------------------------------------------------

export default function TourGuideConfigureSchemaTableToolbar({
  filters,
  onFilters,
  //
  roleOptions,
  setToolbarSchemaIdFromChild,
  setSerachByCodeParent,
  serachByCodeParent,
}) {
  const popover = usePopover();
  const loadingSend = useBoolean();
  const [schemaList, setSchemaList] = useState([]);
  const [schemaName, setSchemaName] = useState('');
  const [searchName, setSearchName] = useState('');
  const [schema, setSchema] = useState('');

  const NewInvoiceSchema = Yup.object().shape({
    // category_id: Yup.mixed().nullable().required('Category Name to is required'),
    // category_level: Yup.mixed().nullable().required('Operation is required'),
  });
  const [loadingSendReports, setpdflorading] = useState(false);
  const [loadingSendReport, setLoadingSendReport] = useState(false);

  const defaultValues = useMemo(
    () => ({
      // category_level: accounts?.category_level || 0,
      // acc_code: accounts?.acc_code || '',
      // name: accounts?.name || '',
    }),
    []
  );

  const methods = useForm({
    resolver: yupResolver(NewInvoiceSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  const handleFilterName = useCallback(
    (event) => {
      // onFilters('name', event.target.value);
      setSerachByCodeParent(event.target.value);
      setSearchName(event.target.value);
    },
    [setSerachByCodeParent]
  );
  const handleFilterStartDate = useCallback(
    (newValue) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );
  useEffect(() => {
    const fetchTourGuideSchemas = async () => {
      try {
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
        };
        const param = {
          name: schemaName || '',
        };
        const response = await postPramsFetcher1(
          `${endpoints.tourGuide.search}/${0}/${10}/${0}`,
          null,
          param,
          config
        );

        console.log('Response from fetchTourGuideSchemas:', response?.data?.content);

        if (response && response.status === 200) {
          setSchemaList(response?.data?.content || []);
        } else {
          enqueueSnackbar('Failed to fetch tour guide schemas', {
            variant: 'error',
            autoHideDuration: 5000,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            sx: { width: '400px' },
          });
        }
      } catch (error) {
        enqueueSnackbar('Failed to fetch tour guide schemas', {
          variant: 'error',
          autoHideDuration: 5000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
        });
      }
    };
    fetchTourGuideSchemas();
  }, [schemaName]);

  useEffect(() => {
    setToolbarSchemaIdFromChild(schema, searchName);
  }, [setToolbarSchemaIdFromChild, schema, searchName]);
  return (
    <>
      <Stack
        spacing={2}
        alignItems={{ xs: 'flex-end', md: 'center' }}
        direction={{
          xs: 'column',
          md: 'row',
        }}
        sx={{
          p: 2.5,
          pr: { xs: 2.5, md: 1 },
        }}
      >
        {/* <DatePicker
          label="Start date"
          value={filters.startDate}
          onChange={handleFilterStartDate}
          slotProps={{
            textField: {
              fullWidth: true,
            },
          }}
          sx={{
            maxWidth: { md: 200 },
          }}
        />

        <DatePicker
          label="End date"
          value={filters.endDate}
          onChange={handleFilterEndDate}
          slotProps={{ textField: { fullWidth: true } }}
          sx={{
            maxWidth: { md: 200 },
          }}
        /> */}

        <RHFAutocomplete
          name="headerId1"
          label="Schema"
          size="small"
          options={schemaList}
          sx={{ width: 300 }} // You can change 300 to whatever width you prefer
          getOptionLabel={(option) => option.name || ''}
          onInputChange={(_, value) => {
            setSchemaName(value);
          }}
          onChange={(event, value) => {
            console.log('Input changed:', value);
            setSchema(value);
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option?.name || '-'} - {option?.code || '-'}
            </li>
          )}
        />

        <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
          <TextField
            fullWidth
            value={serachByCodeParent}
            onChange={handleFilterName}
            placeholder="Search..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
      </Stack>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            popover.onClose();
          }}
        >
          <Iconify icon="solar:printer-minimalistic-bold" />
          Print
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
          }}
        >
          <Iconify icon="solar:import-bold" />
          Import
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
          }}
        >
          <Iconify icon="solar:export-bold" />
          Export
        </MenuItem>
      </CustomPopover>
    </>
  );
}

TourGuideConfigureSchemaTableToolbar.propTypes = {
  filters: PropTypes.object,
  onFilters: PropTypes.func,
  roleOptions: PropTypes.array,
  setSerachByCodeParent: PropTypes.func,
  serachByCodeParent: PropTypes.func,
  setToolbarSchemaIdFromChild: PropTypes.func,
};
